import React, { useContext, useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconDefinition } from "@fortawesome/fontawesome-common-types";
import cx from "classnames";
import AppContext from "../../state/AppContext";
import UserContext from "../../state/UserContext";
import UserwalkthroughType from "../../types/generic/UserWalkthroughType";
import AlertMenu from "../common/AlertMenu";
import ProfileNav from "../navigation/ProfileNav";

function TopBar() {
  const appContext = React.useContext(AppContext);
  const [pageTitle, setPageTitle] = useState<string>("");
  const [pageIcon, setPageIcon] = useState<IconDefinition | undefined>(
    undefined
  );
  const [showPageTitleAccent, setShowPageTitleAccent] = useState<boolean>(true);
  const [showTopBarTitleSpacing, setShowTopBarTitleSpacing] =
    useState<boolean>(true);
  const [launchWalkthrough, setLaunchWalkthrough] = useState<boolean>(false);
  const [
    activeDashboardTypeForWalkthrough,
    setActiveDashboardTypeForWalkthrough,
  ] = useState<UserwalkthroughType | null>(
    appContext.activeDashboardTypeForWalkthrough
  );

  useEffect(() => {
    setActiveDashboardTypeForWalkthrough(
      appContext.activeDashboardTypeForWalkthrough
    );
    setLaunchWalkthrough(false);
  }, [appContext.activeDashboardTypeForWalkthrough]);

  useEffect(() => {
    setPageTitle(appContext.pageTitle);
  }, [appContext.pageTitle]);

  useEffect(() => {
    setPageIcon(appContext.pageIcon);
  }, [appContext.pageIcon]);

  useEffect(() => {
    setShowPageTitleAccent(appContext.showPageTitleAccent);
  }, [appContext.showPageTitleAccent]);

  useEffect(() => {
    setShowTopBarTitleSpacing(appContext.showTopBarTitleSpacing);
  }, [appContext.showTopBarTitleSpacing]);
  const userContext = useContext(UserContext);

  const handleCloseWalkthrough = () => {
    setLaunchWalkthrough(false);
  };

  return (
    <div
      id="top-bar"
      className={cx(
        "bg-white pl-6 border-b flex flex-row justify-between",
        !showTopBarTitleSpacing && "top-bar--compact"
      )}
    >
      <div className="bg-white flex-1 lg:hidden"></div>
      <div id="header">
        <h3 className="text-xl">
          {pageIcon && (
            <FontAwesomeIcon
              icon={pageIcon}
              className="mr-3 primary-colour"
              size="1x"
            />
          )}
          {pageTitle}
        </h3>
      </div>
      <div className="lg:hidden flex-1">
        <AlertMenu
          defaultAlertData={userContext.user.notifications}
        />
      </div>
      <div className="hidden lg:block pr-8">
        <ProfileNav />
      </div>
    </div>
  );
}

export default TopBar;
